import styled from 'styled-components'

import colors from 'styles/colors'
import { calculatePollPercentage } from 'utils'

interface IPollAnswerOption {
    total: number
    optionCount: number
    answerKey: string
    text: string
}

export const PollAnswerOption = ({
    total,
    optionCount,
    text,
    answerKey
}: IPollAnswerOption) => {
    return (
        <PollOption>
            <Percentage
                style={{
                    width: `${calculatePollPercentage(total, optionCount)}%`
                }}
            ></Percentage>

            <Icon>{answerKey}</Icon>
            <Text>{text}</Text>
            <Count>{optionCount}</Count>
        </PollOption>
    )
}

const PollOption = styled.div`
    background: #ffffff;
    padding: 1.2rem;
    border-radius: 1.5rem;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    flex: 1 1;

    padding: 1.3rem;
    border-radius: 2rem;
    position: relative;
    overflow: hidden;
`

const Percentage = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    background: #b1dbfe;
`

const Icon = styled.div`
    z-index: 1;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.02em;
    font-size: 1.1rem;
    min-width: 2.6rem;
    min-height: 2.6rem;
    border: 0.1rem solid #0d1444;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 1.2rem;
`

const Text = styled.div`
    z-index: 1;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 600;
    letter-spacing: 0.02em;
    font-size: 1.4rem;
    line-height: 1.7rem;
    color: ${colors.blueDark};
    width: 100%;
    background-color: transparent;
    border: none;
    box-shadow: none;
    position: relative;
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
`

const Count = styled.div`
    z-index: 1;
    position: relative;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 800;
    letter-spacing: 0.02em;
    font-size: 1.8rem;
    line-height: 2.2rem;
`
